export class UrlUtils {
    public static normalizeUrl(url: string): string {
        const urlObj = new URL(url);
        const params = Array.from(urlObj.searchParams.entries());

        params.sort(([keyA, valA], [keyB, valB]) =>
            keyA.localeCompare(keyB) || valA.localeCompare(valB)
        );

        urlObj.search = new URLSearchParams(params).toString();
        return urlObj.toString();
    }
}
